<template>
  <Header />
  <!-- <Breadcrumb title="Platform Details" subtitle="" />-->
  <OptOutDetail />
  <!--<PaginationArea :detailIndex="detailIndex" />-->
  <!--<FeaturesArea />-->
  <Footer />
</template>

<script>
import Header from "../../components/Home/Header.vue";
//import Breadcrumb from "../../components/common/Breadcrumb.vue";
import OptOutDetail from "../../components/OptOut/OptOutDetail.vue";

//import PaginationArea from "../../components/PlatformDetails/PaginationArea.vue";
//import FeaturesArea from "../../components/PlatformDetails/FeaturesArea.vue";
import Footer from "../../components/Home/AppFooter.vue";

export default {
  name: "OptOutDetails",
  components: {
    Header,
    //  Breadcrumb,
    OptOutDetail,
    //PaginationArea,
    //  FeaturesArea,
    Footer,
  },
};
</script>